/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PickListOptionFromJSON, PickListOptionToJSON, PickListThemeFromJSON, PickListThemeToJSON, } from './';
export function PickListPresentationFromJSON(json) {
    return PickListPresentationFromJSONTyped(json, false);
}
export function PickListPresentationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'options': !exists(json, 'options') ? undefined : (json['options'].map(PickListOptionFromJSON)),
        'themeOverride': !exists(json, 'theme_override') ? undefined : PickListThemeFromJSON(json['theme_override']),
    };
}
export function PickListPresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'options': value.options === undefined ? undefined : (value.options.map(PickListOptionToJSON)),
        'theme_override': PickListThemeToJSON(value.themeOverride),
    };
}
//# sourceMappingURL=PickListPresentation.js.map